import { Compass } from "lucide-react";
import { Link } from "react-router-dom";
import SeoHead from "../../components/common/SeoHead";

function CountryNotFoundPage() {
  return (
    <>
      <SeoHead
        title="Study Destination | NextEra Abroad"
        description="Explore active study destinations with NextEra Abroad and get personalized support for shortlisting, admissions, and visa planning."
        path="/study-in"
        keywords={[
          "study destinations",
          "study abroad countries",
          "overseas education counselling"
        ]}
      />
      <section className="relative overflow-hidden pb-20 pt-40">
        <div className="hero-grid absolute inset-0 opacity-45" />
        <div className="relative mx-auto w-full max-w-4xl px-6 text-center">
          <div className="mx-auto inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-sky-glow text-royal-blue shadow-soft">
            <Compass className="h-7 w-7" aria-hidden="true" />
          </div>
          <h1 className="mt-6 text-3xl sm:text-4xl md:text-6xl">Destination Page Not Found</h1>
          <p className="mx-auto mt-6 max-w-2xl text-sm text-slate-text/80 sm:text-base md:text-lg">
            The destination you searched for is not available. Explore our active country pages or
            book a free counselling session for personalized guidance.
          </p>
          <div className="mt-10 flex flex-col justify-center gap-3 sm:flex-row">
            <Link
              to="/"
              className="inline-flex justify-center rounded-xl bg-midnight-navy px-6 py-3 text-sm font-semibold text-soft-white hover:bg-royal-blue"
            >
              Back to Home
            </Link>
            <Link
              to="/contact#contact-form"
              className="inline-flex justify-center rounded-xl border border-midnight-navy/15 bg-white px-6 py-3 text-sm font-semibold text-midnight-navy"
            >
              Book Free Counselling
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default CountryNotFoundPage;
